import { useQuery } from '@tanstack/react-query';
import type { StartAttemptsResponse, StartSuccessRange, StartSuccessResponse } from '@evi/shared';
import { fetchStartAttempts, fetchStartSuccess } from '@/lib/api';
import { useDashboardIdentity } from './useDashboardIdentity';

/**
 * Session success data hooks: the start success rollup (charger page card,
 * and the anomalies page when it reads it) and one charger's start attempts.
 * Gated on Dashboard.read server-side, like start-timeouts: no retry, one
 * 403 hides the card.
 */
export function useStartSuccess(range: StartSuccessRange = '7d') {
  const identity = useDashboardIdentity();
  return useQuery<StartSuccessResponse>({
    queryKey: ['dashboard', identity, 'start-success', range],
    queryFn: () => fetchStartSuccess(range),
    staleTime: 60_000,
    retry: false,
  });
}

export function useStartAttempts(chargerId: string, range: StartSuccessRange = '30d') {
  const identity = useDashboardIdentity();
  return useQuery<StartAttemptsResponse>({
    queryKey: ['dashboard', identity, 'start-attempts', chargerId, range],
    queryFn: () => fetchStartAttempts(chargerId, range),
    staleTime: 60_000,
    retry: false,
  });
}
